<template>
<span v-bind="$attrs" :title="'Gamma ' + mapaNomGamma[props.gamma]"  :alt="'Gamma ' + mapaNomGamma[gamma]"><font-awesome-icon v-for="n in Estrelles[gamma]" :icon="['fas','star']" :key="n"/><font-awesome-icon v-if="Mig[gamma]" :icon="['fas','star-half']"/><span v-if="gamma=='pc'" class="text-sm text-gray-600">Per catalogar</span></span>
</template>

<script setup>
import {defineProps} from 'vue'
const props = defineProps({
gamma:{
  type:String,
  default:'a6'
}
}
)
const Estrelles={
        b6:0,
        a6:1,
        b7:1,
        a7:2,
        b8:2,
        a8:3,
        b9:3,
        ex:4,
        sp:5,

        b5u:0,
        a5u:1,
        b6u:1,
        a6u:2,
        b7u:2,
        a7u:3,
        b8u:3,
        exu:4,
        spu:5,

        pc:0
}

const Mig={
        b6:true,
        a6:false,
        b7:true,
        a7:false,
        b8:true,
        a8:false,
        b9:true,
        ex:false,
        sp:false,

        b5u:true,
        a5u:false,
        b6u:true,
        a6u:false,
        b7u:true,
        a7u:false,
        b8u:true,
        exu:false,
        spu:false,

        pc:false
}


    const mapaNomGamma={
        b6:"Bàsica de 6",
        a6:"Alta de 6",
        b7:"Bàsica de 7",
        a7:"Alta de 7",
        b8:"Bàsica de 8",
        a8:"Alta de 8",
        b9:"Bàsica de 9",
        ex:"Extra",
        sp:"Superior",

        b5u:"Bàsica de 5 Universitària",
        a5u:"Alta de 5 Universitària",
        b6u:"Bàsica de 6 Universitària",
        a6u:"Alta de 6 Universitària",
        b7u:"Bàsica de 7 Universitària",
        a7u:"Alta de 7 Universitària",
        b8u:"Bàsica de 8 Universitària",
        exu:"Extra Universitària",
        spu:"Superior Universitària",

        pc:"Per Catalogar"
    }

//console.log(props.gamma,Mig[props.gamma])

</script>